import React from 'react'
import { RadioGroup } from '@headlessui/react'
import clsx from 'clsx'
import { FieldData } from '.'

interface ReasoningEffortSelectorProps {
  field: FieldData
  formik: any
}

const EFFORT_LEVELS = [
  {
    value: 'normal',
    label: 'Normal',
    description: 'Standard with basic reasoning',
  },
  {
    value: 'enhanced',
    label: 'Enhanced',
    description: 'More detailed with deeper consideration',
  },
  {
    value: 'advanced',
    label: 'Advanced',
    description: 'Comprehensive with multiple approaches',
  },
  {
    value: 'maximum',
    label: 'Maximum',
    description: 'Most thorough possible with all considerations',
  },
]

const ReasoningEffortSelector: React.FC<ReasoningEffortSelectorProps> = ({ field, formik }) => {
  return (
    <div>
      <RadioGroup
        value={formik.values[field.name]}
        onChange={(value) => formik.setFieldValue(field.name, value)}
        className="mt-2"
      >
        <div className="space-y-2">
          {EFFORT_LEVELS.map((level) => (
            <RadioGroup.Option
              key={level.value}
              value={level.value}
              className={({ checked }) =>
                clsx(
                  'relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none',
                  checked
                    ? 'bg-flowmo-blue-600 text-white'
                    : 'bg-white text-gray-900 hover:bg-gray-50'
                )
              }
            >
              {({ checked }) => (
                <div className="flex w-full items-center justify-between">
                  <div className="flex items-center">
                    <div className="text-sm">
                      <RadioGroup.Label
                        as="p"
                        className={clsx('font-medium', checked ? 'text-white' : 'text-gray-900')}
                      >
                        {level.label}
                      </RadioGroup.Label>
                      <RadioGroup.Description
                        as="span"
                        className={clsx('inline', checked ? 'text-blue-100' : 'text-gray-500')}
                      >
                        {level.description}
                      </RadioGroup.Description>
                    </div>
                  </div>
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
      {formik.touched[field.name] && formik.errors[field.name] ? (
        <div className="text-red-500 text-xs mt-1">{formik.errors[field.name]}</div>
      ) : null}
    </div>
  )
}

export default ReasoningEffortSelector
